import { security } from './security'

export function getModules() {
  return {
    security,
  }
}

export function getPersistModules() {
  return ['security']
}
